import styled from "styled-components";

export const StyledContainer = styled("div")`
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

export const LabListContainer = styled("div")`
  display:flex;
  flex-direction:column;
  text-align: left;
  justify-content: left;
  align-items: left;
  direction:rtl;
`;

export const ButtonContainer = styled("div")`
  height:100%;
  width:100%;
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 5px;
`;

export const SumContainer = styled("div")`
  text-align: right;
  direction:rtl;
`;


export const InfoText = styled("p")`
  font-size:14px;
  margin-right:5px;
  direction:rtl;
  text-align:right;
  width:100%;
  margin-bottom:5px;
`;

export const UploadContainer = styled("div")`
  width:100%;
  height:100%;
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

